const PREFIX = {
  LOGIN: '/login',
  APP: '/app',
};
export const ROUTES = {
  LOGIN: {
    PATH: `${PREFIX.LOGIN}/:role?`,
    SUPPLIER: `${PREFIX.LOGIN}/proveedor`,
    USER: `${PREFIX.LOGIN}/usuario`,
    SIGN_UP: `${PREFIX.LOGIN}/signUp`,
    RECOVERY: `${PREFIX.LOGIN}/recovery`,
    CONFIRM: `${PREFIX.LOGIN}/confirm/:token/:type`,
    PASSWORD_CHANGE: `${PREFIX.LOGIN}/passwordChange/:token/:type`,
  },
  PATH: `${PREFIX.APP}/:path?`,
  HOME: `${PREFIX.APP}/home`,
  CHECKING_ACCOUNT: `${PREFIX.APP}/checkingAccount`,
  PAYMENT_ORDERS_WITHHOLDINGS: `${PREFIX.APP}/paymentOrdersWithholdings`,
  EXCHANGE_DIFFERENCE: `${PREFIX.APP}/exchangeDifference`,
  NOTIFICATIONS: `${PREFIX.APP}/notifications`,
  CLAIM_MGMT: `${PREFIX.APP}/claimManagement`,
  CLAIM_STATS: `${PREFIX.APP}/claimStatistics`,
  PURCHARSE_ORDERS: `${PREFIX.APP}/purchaseOrders`,
  SERVICE_PAGE: `${PREFIX.APP}/servicePages`,
  MERCHANDISE_REMITTANCE: `${PREFIX.APP}/merchandiseRemittance`,
  USER_ADMINISTRATION: `${PREFIX.APP}/userAdministration`,
  EMPLOYEE_ADMINISTRATION: `${PREFIX.APP}/employeeAdministration`,
  LOGISTICS: `${PREFIX.APP}/logistics`,
  MY_ACCOUNT: `${PREFIX.APP}/myAccount`,
  COMUNICATION_SITES:`${PREFIX.APP}/comunicationSites`,
  HELP_INFORMATION:`${PREFIX.APP}/helpInformation`,
  SCRAPS: `${PREFIX.APP}/scraps`,
  MATERIALS_REQUIRES:`${PREFIX.APP}/materialsRequires`,
  QUALITY_CERTIFICATE_REQUESTS:`${PREFIX.APP}/qualityCertificateRequests`,
  EXCLUDED_SUPPLIERS_CERTIFICATE: `${PREFIX.APP}/excludedSupplierQualityCertificate`,
  EXCLUDED_PURCHASE_ORDERS:`${PREFIX.APP}/excludedCertificatePurchaseOrders`,
  EMPLOYEES: `${PREFIX.APP}/employees`,
  ACTIVITY_LOGS: `${PREFIX.APP}/activityLogs`,
  EMAIL_NOTIFICATION: `${PREFIX.APP}/emailNotification`
};
